import CustomEase from "../utils/gsap/CustomEase";
import gsap from "gsap";

export default {
  install(Vue) {
    // gsap 의존성 플러그인 등록
    gsap.registerPlugin(CustomEase);
    // 뷰인스턴스 라이브러리로 등록, `this.$gsap` 형태로 사용가능
    Vue.prototype.$gsap = gsap;

    // ## 배포용 빌드시 중요사항 ##
    // IE에서 로띠파일 로드시 json 경로 이슈로 분기처리 로직, `this.$constants` 변수로 사용
    const isProd = process.env.NODE_ENV === "production";
    const isIE = window.browserInfo && window.browserInfo.engine === "i";
    Vue.prototype.$constants = {
      lottiePath:
        isProd && isIE
          ? "https://mini.koreainvestment.com/stock/br/json"
          : "json",
    };

    // ## 배포용 빌드시 중요사항 ##
    // 미니스탁 실서비스가 `mini.koreainvestment.com/stock/br` 에서 호스팅되고 있음
    // 따라서 a link 이동시에는 실서비스 빌드시 경로 형태가 '/stock/br/*' 형태가 되어야 함
    // 참고) vue.config.js 파일에서 process.env.HOME_PATH 셋팅값 분기처리 로직
    // vue 컴포넌트 내부에서 `$HOME_PATH` 변수로 사용중
    Vue.prototype.$HOME_PATH = process.env.HOME_PATH || "/";

    // 화면 높이값 잡아주는 공통 메서드 로직
    Vue.mixin({
      mounted() { },
      methods: {
        //스크롤링 CSS 세팅으로 밑으로 내리는 작업 수행
        setImgMaxHeight(parentSelector, idx, exception) {
          window.addEventListener('resize', function (event) {
            const wrapContent = document.querySelector(
              `${parentSelector} .child`
            );
            const main_videoContent = document.querySelector(
              `${parentSelector} .main_video`
            );
            if (wrapContent) {
              wrapContent.setAttribute("style", `height:${window.innerHeight}px; min-height:${window.innerHeight}px; margin-top:${window.innerHeight * idx}px;`);
            }
            if (main_videoContent && !exception) {
              main_videoContent.setAttribute("style", `height:${window.innerHeight}px`);
            }
          }, true);
        },
        setSelectImgMaxHeight(parentSelector, idx, opacity) {
          window.addEventListener('resize', function (event) {
            const wrapContent = document.querySelector(
              `${parentSelector} .child`
            );
            const main_videoContent = document.querySelector(
              `${parentSelector} .main_video`
            );
            if (wrapContent) {
              wrapContent.setAttribute("style", `height:${window.innerHeight}px; min-height:${window.innerHeight}px; margin-top:${window.innerHeight * idx}px; opacity: ${window.shareCurrentIdx === opacity ? 1 : 0};`);
            }
            if (main_videoContent) {
              main_videoContent.setAttribute("style", `height:${window.innerHeight}px`);
            }
          }, true);
        },
        setSelectMaxHeight(parentSelector, idx, opacity) {
          window.addEventListener('resize', function (event) {
            const wrapContent = document.querySelector(
              `${parentSelector}`
            );
            if (wrapContent) {
              wrapContent.setAttribute("style", `height:${window.innerHeight}px; min-height:${window.innerHeight}px; margin-top:${window.innerHeight * idx}px; opacity: ${window.shareCurrentIdx === opacity ? 1 : 0};`);
            }
          }, true);
        },
        setMoblieImgMaxHeight(parentSelector, idx, exception) {
          window.addEventListener('resize', function (event) {
            const wrapContent = document.querySelector(
              `${parentSelector}`
            );
            const main_videoContent = document.querySelector(
              `${parentSelector} .main_video`
            );
            if (wrapContent) {
              wrapContent.setAttribute("style", `height:${window.innerHeight}px;`);
            }
            if (main_videoContent && !exception) {
              main_videoContent.setAttribute("style", `height:${window.innerHeight}px;`);
            }
          }, true);
        },
        setMobileSelectMaxHeight(parentSelector, idx, display) {
          if (document.querySelector(`.section${display - 1}_m`)) {
            document.querySelector(`.section${display - 1}_m`).setAttribute("style", `display: none; opacity: 0;`);
          }
          document.querySelector(`.section${display}_m`).setAttribute("style", `display: ${window.shareCurrentIdx === display ? 'block' : 'none'}; opacity: 1;`);
          if (document.querySelector(`.section${display + 1}_m`)) {
            document.querySelector(`.section${display + 1}_m`).setAttribute("style", `display: none; opacity: 0;`);
          }
          window.addEventListener('resize', function (event) {
            const wrapContent = document.querySelector(
              `${parentSelector}`
            );
            if (wrapContent) {
              wrapContent.setAttribute("style", `display: ${window.shareCurrentIdx === display ? 'block' : 'none'};`);
            }
          }, true);
        },

      },
    });
  },
};
